export const ArticleCategories = {
  'vse-o-nakupu': 'Vše o nákupu',
  sluzby: 'Služby',
  'o-spolecnosti': 'O společnosti',
};
